import {AbstractVisualFeature, allVisuals} from '#core/application/modules/visual-feature.js';

import SCHEMA from './skeleton.schema.yaml';

class SkeletonFeature extends AbstractVisualFeature {
    get name() {
        return 'Skeleton';
    }

    get enabled() {
        // Feature itself is always enabled
        return true;
    }

    get configSchema() {
        return SCHEMA;
    }

    get show() {
        return this.config.show ?? true;
    }

    get showOnHomePage() {
        return this.config.showOnHomePage ?? this.show;
    }

    getSerializableVisualConfig() {
        return {
            LoaderSuspense: {
                disableLoader: !this.show,
            },
            HighlightsView: {
                eventCardsCarousel: {
                    skeletonLoader: {
                        disableLoader: true, // according to MOJ-14036
                    },
                },
                menuLinkPromotions: {
                    skeletonLoader: {
                        disableLoader: true, // according to MOJ-14036
                    },
                },
            },
            OutrightsView: {
                topLeagues: {
                    sportGroupsListView: {
                        skeletonLoader: {
                            disableLoader: !this.show,
                        },
                    },
                },
                allLeagues: {
                    sportGroupsListView: {
                        skeletonLoader: {
                            disableLoader: !this.show,
                        },
                    },
                },
            },
        };
    }
}

export const Skeleton = new SkeletonFeature(allVisuals);
